export default "__VITE_ASSET___g7uWdLt__"